import { render, staticRenderFns } from "./nhs-reg-stats.html?vue&type=template&id=79752f39&"
import script from "./nhs-reg-stats.js?vue&type=script&lang=js&"
export * from "./nhs-reg-stats.js?vue&type=script&lang=js&"
import style0 from "./nhs-reg-stats.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports